<template>
  <div class="content-pane content-pane_white">
    <div class="aside-nav-tabs">
      <template v-for="(item, key) in links">
        <router-link
          active-class="active"
          class="aside-nav-tabs__item"
          :key="key"
          :to="item.path"
          >{{ item.title }}</router-link
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array
  }
};
</script>

<style lang="scss" scoped>
.aside-nav-tabs {
  &__item {
    background-color: lighten($gray-10, 3%);
    border-radius: 3px;
    color: $text-color-default;
    display: block;
    padding: 8px 12px 7px;
    text-decoration: none;
    transition: all ease-in-out 0.1s;

    &:not(:last-of-type) {
      margin-bottom: 2px;
    }

    &:hover,
    &:focus {
      background-color: darken($gray-10, 1%);
    }

    &.active {
      background-color: $yellow-default;
    }
  }
}
</style>